// 用户设置类型定义
export interface UserSettings {
  language: string;
  timezone: string;
  theme?: 'light' | 'dark' | 'auto';
}

export interface LanguageOption {
  code: string;
  name: string;
  flag: string;
}

export interface TimezoneOption {
  code: string;
  name: string;
  offset: string;
  utcOffset: number;
}

// 支持的语言列表
export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'zh-CN', name: '中文(简体)', flag: '🇨🇳' },
  { code: 'zh-TW', name: '中文(繁体)', flag: '🇹🇼' },
  { code: 'en-US', name: 'English', flag: '🇺🇸' },
  { code: 'ja-JP', name: '日本語', flag: '🇯🇵' },
  { code: 'ko-KR', name: '한국어', flag: '🇰🇷' },
];

// 支持的时区列表
export const SUPPORTED_TIMEZONES: TimezoneOption[] = [
  { code: 'Asia/Shanghai', name: '北京时间 (UTC+8)', offset: 'UTC+8', utcOffset: 8 },
  { code: 'Asia/Taipei', name: '台北时间 (UTC+8)', offset: 'UTC+8', utcOffset: 8 },
  { code: 'Asia/Tokyo', name: '东京时间 (UTC+9)', offset: 'UTC+9', utcOffset: 9 },
  { code: 'Asia/Seoul', name: '首尔时间 (UTC+9)', offset: 'UTC+9', utcOffset: 9 },
  { code: 'America/New_York', name: '纽约时间 (UTC-5)', offset: 'UTC-5', utcOffset: -5 },
  { code: 'Europe/London', name: '伦敦时间 (UTC+0)', offset: 'UTC+0', utcOffset: 0 },
  { code: 'Europe/Paris', name: '巴黎时间 (UTC+1)', offset: 'UTC+1', utcOffset: 1 },
  { code: 'Pacific/Auckland', name: '奥克兰时间 (UTC+12)', offset: 'UTC+12', utcOffset: 12 },
];

// 默认设置
export const DEFAULT_SETTINGS: UserSettings = {
  language: 'zh-CN',
  timezone: 'Asia/Shanghai',
  theme: 'auto',
};
